"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fp = require("lodash/fp");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var longDurations = {
  M: 'month',
  d: 'day',
  y: 'year'
};
var shortDurations = {
  M: 'mth',
  d: 'day',
  y: 'yr'
};
var durationRegexp = new RegExp("(\\d+)(".concat((0, _fp.keys)(longDurations).join('|'), ")$"));

/*
 * Formats a waiting period for display.
 *
 * @param {string=} duration - The waiting period duration from the API, for example `2M` or `14d`.
 * @param {bool=} isShort - Returns a shorter string when true.
 * @returns {string} formatted waiting period, for example `1 month` or `None`.
 */
var formatWaitingPeriod = function formatWaitingPeriod(duration) {
  var isShort = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if ((0, _fp.isNil)(duration)) {
    return 'None';
  }
  var matches = duration.match(durationRegexp);
  if ((0, _fp.isNull)(matches)) {
    return duration;
  }
  var _matches = _slicedToArray(matches, 3),
    number = _matches[1],
    unit = _matches[2];
  var suffix = (0, _fp.toNumber)(number) > 1 ? 's' : '';
  var formattedDurations = isShort ? shortDurations : longDurations;
  return "".concat(number, " ").concat(formattedDurations[unit]).concat(suffix);
};
var _default = exports["default"] = formatWaitingPeriod;
module.exports = exports.default;